import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import SEO from '@/components/SEO';
import { Link } from 'react-router-dom';

const Founder = () => {
  const [f, setF] = useState(null);
  useEffect(() => { api.get('/content/founder').then(({ data }) => setF(data)); }, []);
  if (!f || !f.name) return <div className="sans-container sans-section text-sans_mute">Loading…</div>;

  return (
    <>
      <SEO title="Founder" description={f.mission} canonical={typeof window !== 'undefined' ? window.location.href : ''} />
      <div className="bg-sans_bone">
        <section className="sans-section">
          <div className="sans-container grid md:grid-cols-12 gap-12 md:gap-16">
            <div className="md:col-span-5">
              <div className="aspect-[3/4] bg-sans_line overflow-hidden grayscale">
                <img src={f.portrait} alt={f.name} className="w-full h-full object-cover" />
              </div>
              <div className="mt-6">
                <div className="sans-label mb-2">From the Founder</div>
                <div className="font-serif text-2xl text-sans_ink">{f.name}</div>
                <div className="text-sm text-sans_mute mt-1">{f.role}</div>
              </div>
            </div>
            <div className="md:col-span-7 md:pl-8">
              <div className="sans-label mb-6">Our story</div>
              <h1 className="sans-h1">Why Saans Ayurved exists.</h1>
              <div className="sans-rule mt-8" />
              <div className="mt-12 text-lg leading-relaxed text-sans_ink font-serif whitespace-pre-line">
                {f.story}
              </div>
              {(f.mission || f.vision) && (
                <div className="mt-12 grid sm:grid-cols-2 gap-8">
                  {f.mission && (
                    <div>
                      <div className="sans-label mb-3">Mission</div>
                      <p className="text-sans_ink leading-relaxed">{f.mission}</p>
                    </div>
                  )}
                  {f.vision && (
                    <div>
                      <div className="sans-label mb-3">Vision</div>
                      <p className="text-sans_ink leading-relaxed">{f.vision}</p>
                    </div>
                  )}
                </div>
              )}
              {f.why && (
                <div className="mt-12 border-l-2 border-sans_ink pl-6 font-serif text-2xl text-sans_ink italic">
                  "{f.why}"
                </div>
              )}
              <div className="mt-16 flex flex-wrap gap-4">
                <Link to="/assessment" className="sans-btn-primary">Take the free assessment</Link>
                <Link to="/consultation" className="sans-btn-secondary">Book a consultation</Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Founder;
